import { CheckboxFilterComponent } from '@/shared/components/table/components/checkbox-filter/checkbox-filter.component';
import { PageDirection, TableDataSource } from "@/shared/components/table/table.model";
import { ClusterElementFragment, ClusterElementsGQL } from "@/core/graphql/graphql";
import { PaginatorComponent } from "@/shared/components/table/components/paginator/paginator.component";
import { CollectionViewer } from "@angular/cdk/collections";
import { MatSort } from "@angular/material/sort";
import { FilterComponent } from "@/shared/components/table/components/filter/filter.component";
import { SearchbarComponent } from "@/shared/components/table/components/searchbar/searchbar.component";
import { BehaviorSubject, Observable } from "rxjs";

export class ClusterElementsDataSource extends TableDataSource<ClusterElementFragment> {
  public paginator: PaginatorComponent;
  public searchbar: SearchbarComponent;
  public sort: MatSort;
  public filter: FilterComponent;
  private _elementsSubject = new BehaviorSubject<ClusterElementFragment[]>([]);

  public constructor(
    private readonly _clusterElementsGql: ClusterElementsGQL,
    private readonly _clusterId: number,
  ) {
    super();
  }

  public set checkboxFilter(component: CheckboxFilterComponent) {}

  public connect(_: CollectionViewer): Observable<readonly ClusterElementFragment[]> {
    return this._elementsSubject.asObservable();
  }

  public disconnect(collectionViewer: CollectionViewer): void {
    this._elementsSubject.complete();
  }

  public onPaginationChange(requestedChange: PageDirection): void {
  }

  public loadData(): void {
    this._clusterElementsGql.fetch({
      id: this._clusterId,
      meta: {
        pageSize: 10,
        pageCursor: undefined,
      },
    }).subscribe( (x) => {
      this._elementsSubject.next(x.data.cluster.elements.items);
    });
  }
}
